// Scroll/load reveal animations driven by global Animations settings.
// Elements opt in with [data-animate]; children stagger with [data-animate-children].
// Settings arrive as CSS variables: --mv-anim-duration (ms), --mv-anim-init-delay (ms),
// --mv-anim-child-delay (ms), --mv-anim-start-opacity (0-1), --mv-anim-start-x (%), --mv-anim-start-y (%).
// Repeat behaviour comes from <body data-animations-repeat="true|false">.
(() => {
  const root = document.documentElement;
  const repeat = document.body.dataset.animationsRepeat === 'true';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) { root.classList.add('animations-disabled'); return; }
  const observer = new IntersectionObserver((entries) => {
    for (const e of entries) {
      const el = e.target;
      if (e.isIntersecting) {
        el.classList.add('animate--visible');
        if (!repeat) observer.unobserve(el);
      } else if (repeat) {
        el.classList.remove('animate--visible');
      }
    }
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
  const init = (scope = document) => {
    scope.querySelectorAll('[data-animate]:not(.animate--ready)').forEach((el) => {
      el.classList.add('animate--ready');
      if (el.hasAttribute('data-animate-children')) {
        [...el.children].forEach((child, i) => child.style.setProperty('--child-index', i));
      }
      observer.observe(el);
    });
  };
  init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  new MutationObserver((m) => m.forEach((r) => r.addedNodes.forEach((n) => n.nodeType === 1 && init(n)))).observe(document.body, { childList: true, subtree: true });
})();
